<template>
  <div v-if="locations">
    <div class="flex justify-between flex-wrap hover:bg-grey-lighter leading-loose px-1 text-center font-bold uppercase tracking-wide text-xs">
      <span class="w-2/5 text-left">Location Name</span>
      <span class="w-1/5">Annual Cost</span>
      <span class="w-1/5"></span>
    </div>
    <div v-for="location in locations">
      <div class="flex justify-between flex-wrap hover:bg-grey-lighter leading-loose px-1 text-center">
        <span class="w-2/5 text-left">{{ location.name }}</span>
        <span class="w-1/5">{{ amount(location.amount) }}</span>
        <span class="w-1/5 text-right text-red hover:text-red-darker cursor-pointer" @click="cancel(location.id)">Cancel</span>
      </div>
    </div>
    <div class="flex justify-end items-center mt-4">
       <div class="text-sm border-t-4 border-yellow bg-yellow-lighter text-yellow-darker p-2" v-show="multiple">
        Discounted cost is based on quantity. If you remove a location, cost of each will be recalculated at next renewal date.
      </div>
      <div class="w-1/3 text-red hover:text-red-darker text-right" @click="cancelAll"><span class="border-b border-red hover:border-red-darker cursor-pointer">Cancel All Subscriptions</span></div>
    </div>
    <div class="bg-black-80 w-screen h-screen absolute z-100 flex justify-center items-center pin-t pin-l" v-show="modal">
      <div class="w-1/2 bg-white rounded-t p-4 text-center border-t-12 border-red">
        <p class="mb-4">At this time, all cancellations must be done manually. If you're sure you'd like to cancel this subscription, just click the button below and we'll take care of the rest.</p>
        <p>All subscriptions are non-refundable.</p>
        <button class="my-4 button bg-red hover:bg-red-darker text-red-lightest hover:text-white" type="button">Yes I'm sure, cancel my subscription.</button>
        <div class="block text-green hover:text-green-dark text-underline" @click="toggleModal">No, I don't know how I got here. Take me to safety!</div>
      </div>
    </div>
  </div>
  <div v-else>
    No active subscriptions found.
  </div>
</template>

<script>
export default {
  props: ['user', 'locations'],
  data() {
    return {
      modal: false
    }
  },
  computed: {
    multiple() {
      if (this.locations.length > 1) {
        return true
      }
      return false
    }
  },
  mounted() {
    console.log('list', this.locations);

    // axios.get('/api/v1/user/' + this.user.id +'/locations')
    //   .then(({data}) => {
    //     if (data.length) {
    //       this.locations = data
    //     }
    //   })
  },
  methods: {
    amount(value) {
      return value ? '$' + value * .01 : 'COMPED'
    },
    cancel(location) {
      this.toggleModal()
      // return false
      // axios.delete('/api/v1/locations/' + location)
      //   .then(({data}) => {
      //     this.locations = data
      //   })
    },
    cancelAll() {
      axios.delete('/api/v1/user/' + this.user +'/locations')
        .then(({data}) => {
          this.locations = data
        })
    },
    toggleModal() {
      this.modal = !this.modal
    }
  }
}
</script>

